import Vue from 'vue'

Vue.filter('markText', (value, start, end) => {

  const bloques = value.split(' ');
  bloques.splice(start, 0,'<span>')
  bloques.splice(end, 0,'</span>')
  
  return bloques.join(' ')
})